import setupCreateComponent from './setup.create.component';

let setupCreateModule = angular.module('setupcreate', [
  ])

  .component('setupcreate', setupCreateComponent)

  .name;

export default setupCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/setup/create/index.js